import { TravelOption } from 'components/search/bex/enums';
import { TravelOptionsState } from 'components/search/bex/interfaces';

const initialTravelOptionsState: TravelOptionsState = {
  travelOptions: [TravelOption.HOTELS, TravelOption.FLIGHTS_HOTELS, TravelOption.FLIGHTS],
};

export { initialTravelOptionsState };
